import React from 'react';
import { Text, Flex } from '@opendoor/bricks/core';
import ImgixImg from '@opendoor/bricks/utils/ImgixImg';

/** TODO: Add documentation */
export const EarliestAvailabilityLabel: React.FC = () => (
  <Flex>
    <ImgixImg width={18} height={18} src="d761993fcdea46d8aa734d928abf4dfe.svg" alt="" />
    <Text fontSize="s0" lineHeight="s00" fontWeight="bold" color="green50">
      Earliest availability
    </Text>
  </Flex>
);
